import { FillInTeacherInformationPage } from './fill-in-teacher-information/FillInTeacherInformationPage'

export default function TeacherRequestDetailPage() {
  return (
    <div className="bg-white">
      <FillInTeacherInformationPage />
    </div>
  )
}
